// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"00720f41","598":"af0b02f2","703":"6456485d"}[chunkId] + ".chunk.js";
};